export const musicCollection_8147 = {
    "@type": "Context",
    "id": 8147,
    "title": "Opgewekt",
    "description": "07",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Style",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Style",
            "value": [
                {
                    "value": "Country",
                    "selected": true
                },
                {
                    "value": "Dance",
                    "selected": true
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                },
                {
                    "value": "Soul",
                    "selected": true
                },
                {
                    "value": "ALL_OTHERS",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1980,
            "maximum": 2018,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2018,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Energy",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Energy",
            "minimum": 3,
            "maximum": 5,
            "step": 1,
            "lowerSelection": 3,
            "upperSelection": 4,
            "metadataDisplayMinimum": "3",
            "metadataDisplayMaximum": "5"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 5,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "5",
            "metadataDisplayMaximum": "6"
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Style",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Style",
            "value": [
                {
                    "value": "Country",
                    "selected": true
                },
                {
                    "value": "Dance",
                    "selected": true
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                },
                {
                    "value": "Soul",
                    "selected": true
                },
                {
                    "value": "ALL_OTHERS",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1980,
            "maximum": 2018,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2018,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Energy",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Energy",
            "minimum": 3,
            "maximum": 5,
            "step": 1,
            "lowerSelection": 3,
            "upperSelection": 4,
            "metadataDisplayMinimum": "3",
            "metadataDisplayMaximum": "5"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 5,
            "maximum": 6,
            "step": 1,
            "lowerSelection": 5,
            "upperSelection": 6,
            "metadataDisplayMinimum": "5",
            "metadataDisplayMaximum": "6"
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": false
}